<template>
  <li class="accordion__item" :class="{ 'flex-grow flex flex-col overflow-hidden': visible && flex }">
    <div class="accordion__trigger  cursor-pointer"
         :class="{ 'accordion__trigger_active': visible,  'min-h-[37px]': flex, 'bg-trader-red' : highlight, 'bg-trader-dark-gray': !highlight}"
         @click="open" :data-ui="'accordion-'+ index">


      <div class="text-center flex items-center justify-center w-full " >
        <div class="ml-1 w-4">
          <span v-if="visible"><i class="fa-solid fa-caret-down text-xl leading-5"></i></span>
          <span v-if="!visible"><i class="fa-solid fa-caret-right text-xl leading-5"></i></span>
        </div>
        <ul :class="titleClass">
          {{ title }}
        </ul>
      </div>
    </div>

    <div ref="t" class="accordion__content overflow-auto" v-show="visible" :class="{ 'flex-grow ': visible && flex }">
      <ul :style="padding ? 'padding: 0px 10px;' : ''" class="formular-container bg-primary"
          :class="{ 'h-full overflow-auto': visible && flex }">

          <slot></slot>
      </ul>
    </div>
  </li>
</template>


<script>

import accordion from "@/components/Accordion/Accordion.vue";

export default {
  computed: {
    accordion() {
      return accordion
    }
  },
  props: {
    padding: {
      type: Boolean,
      default: true
    },
    flex: {
      type: Boolean,
      default: false
    },
    highlight: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ""
    },
    titleClass: {
      type: String,
      default: "w-full text-center"
    }
  },

  inject: ["Accordion"],
  data() {
    return {
      index: null,
      visible: false
    };
  },
  watch: {
    "Accordion.active": function (newVal) {
      if (newVal == this.index) {
        this.visible = true;
      } else {
        this.visible = false;
      }
    }
  },
  methods: {
    open() {
      if (this.visible) {
        this.Accordion.active = null;
      } else {
        this.Accordion.active = this.index;
      }


      this.Accordion.onChange(this.Accordion.active);
    },

    start(el) {
      el.style.height = el.scrollHeight + "px";
    },
    end(el) {
      el.style.height = "";
    },
    findPositionInParent() {
      const parent = this.$el.parentElement;
      const children = Array.from(parent.children);
      const position = children.indexOf(this.$el);

      this.index = position;

      if (this.Accordion.active == this.index) {
        this.visible = true;
      } else {
        this.visible = false;
      }
    }
  },
  mounted() {
    this.findPositionInParent();
  },
  created() {
  }
};
</script>

<style scoped>
.accordion__item {

  
  position: relative;

  margin-bottom: 2px;
}

.accordion__content {
}

.accordion__trigger {
  display: flex;
  justify-content: space-between;
//background: #e0e0e0; height: 37px;
  alignment: center;
}

.accordion__trigger:hover {
  background: #576b80 !important;
  color: white;
}

.accordion-enter-active {
  will-change: height, opacity;
  transition: height 0.3s linear, opacity 0.3s linear;
  overflow: hidden;
}

.accordion-leave-active {
  will-change: height, opacity;
  transition: height 0.3s linear, opacity 0.3s linear;
  overflow: hidden;
}

.accordion-enter,
.accordion-leave-to {
  height: 0 !important;
  opacity: 0;
  overflow: hidden;
}

.accordion__trigger_active {
  background: #576b80 !important;
  color: white;
}
</style>
